
import { Component, Vue } from 'vue-property-decorator';
import ScamAlert from '@/components/scam_alert/ScamAlert.vue';

@Component({
  components: {
    ScamAlert
  }
})
export default class ScamAlertPage extends Vue {
  public language: string = '';

  public get kycOrgCode(): boolean {
    return this.$store.getters['auth/kycOrgConfig'].code;
  }

  public get kycOrgId() {
    return this.$store.getters['auth/kycOrgConfig'].id;
  }
}
